export class DiscordServerBasicInfo {
    id: string;
    name: string;
}